import React, { useEffect, useState } from 'react';
import './App.css';
import {
  HomeRounded,
  Chat,
  AccountBalanceWallet,
  Favorite,
  SummarizeRounded,
  Settings } from '@mui/icons-material';
import Header from './components/Header';
import BannerName from './components/BannerName';
import MenuContainer from './components/MenuContainer';
import SubMenuContainer from './components/SubMenuContainer';
import MenuCard from './components/MenuCard';
import {MenuItems, Items} from './components/Data';
import ItemCard from './components/ItemCard';
import DebitCard from './components/DebitCard';
import CartItem from './components/CartItem';
import { useStateValue } from './components/StateProvider';

function App() {

  //main dish state
  const [isMainData, setMainData] = useState(
    Items.filter(element => element.itemId === 'buger01')
  )

  const[{cart}, dispatch] = useStateValue();

  useEffect(() => {
    const menuLi = document.querySelectorAll('#menu li');
    
    function setMenuActive() {
      menuLi.forEach((n) => n.classList.remove("active"));
      this.classList.add("active");
    }
    menuLi.forEach((n) => n.addEventListener('click',setMenuActive));

    //Menu Card active toggle
     const menuCards = document.querySelector('.rowContainer').querySelectorAll(".rowMenuCard");
     
    function setMenuCardActive(){
      menuCards.forEach((n) => n.classList.remove("active"));
      this.classList.add("active");
    }


     menuCards.forEach(n => n.addEventListener('click',setMenuCardActive));

  },[isMainData,cart]);

  //Set Main dish item
  const setData = (itemId) =>{
    setMainData(Items.filter(element => element.itemId === itemId))
  }

  return (
    <div className="App">
      {/* Header section */}
        <Header/>
      {/* main container */}
         <main>
          <div className="mainContainer">
            {/* Banner */}
            <div className="banner">
              < BannerName name={"somesh"} discount={"20"} link={"#"}/>
              <img
              src="https://firebasestorage.googleapis.com/v0/b/food-delivery-37c59.appspot.com/o/Images%2Fdelivery.png?alt=media&token=69b9823d-96df-452a-bd4e-14d27a4cc337"
              alt=""
              className="deliveryPic"
            />
            </div>

            {/* dish container */}
            <div className="dishContainer">
              <div className="menuCard">
                <SubMenuContainer name={"Menu Category"}/>
              </div>
              <div className="rowContainer">

                {
                  MenuItems && MenuItems.map((data) => (
                    <div key={data.id} onClick={() => setData(data.itemId)}>
                    <MenuCard 
                    imgSrc={data.imgSrc} 
                    name={data.name}
                    isActive = {data.id === 1 ? true : false}
                    />
                  </div>

                  ))
                }
                
              </div>
              
              <div className="dishitemContainer">
                {
                  isMainData && isMainData.map(data => (
                    <ItemCard key={data.id} 
                    itemId ={data.id}
                    imgSrc={data.imgSrc} 
                    name={data.name} 
                    ratings={data.ratings} 
                    price={data.price} />
                  ))
                }
               
              </div>
            </div>
          </div>
          <div className="rightMenu">
            <div className="debitCardContainer">
              <div className="debtCard">
                <DebitCard/>
              </div>
            </div>

            {
              !cart ? 
              (<div className="addSomeItem">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/food-delivery-37c59.appspot.com/o/Images%2FemptyCart.png?alt=media&token=50b733d4-cdd9-4025-bffe-8efa4066ca24"
                alt=""
                className="emptyCart"
              />
            </div>) : 
              <div className="cartCheckOutContainer">
                <SubMenuContainer name={"cart Items"}/>
              <div className="cartContainer">
                <div className="cartItems">
                  {cart && cart.map(data => (
                    <CartItem
                    key={data.id}
                    itemId={data.id}
                  name={data.name}
                  imgSrc={data.imgSrc}
                  price={data.price}
                  />
                  ))}
                  
                </div>
              </div>
              <div className="totalSection">
                <h3>Total:</h3>
               <p><span>₹</span>1000</p> 
              </div>
              <button className="checkOut">Check Out</button>
            </div>
            }
           
          </div>
         </main>
      {/* bottom menu */}
      <div className="bottomMenu">
        <ul id="menu">
          {/* prettier-ignore */}
          <MenuContainer link={'#'} icon ={<HomeRounded/>} isHome/>
          {/* prettier-ignore */}
          <MenuContainer link={'#'} icon ={<Chat/>}/>
          {/* prettier-ignore */}
          <MenuContainer link={'#'} icon ={<AccountBalanceWallet/>}/>
          {/* prettier-ignore */}
          <MenuContainer link={'#'} icon ={<Favorite/>}/>
          {/* prettier-ignore */}
          <MenuContainer link={'#'} icon ={<SummarizeRounded/>}/>
          {/* prettier-ignore */}
          <MenuContainer link={'#'} icon ={<Settings/>}/>

          <div className="indicator"></div>
        </ul>
      </div>
    </div>
  );
}

export default App;
